import Http from "../Http";
import { LARAVEL_BACKEND_API_URL } from "../Helper";

/**
 * Get available installer subscription plans list
 */
export function getInstallerPlans() {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      const url = `${LARAVEL_BACKEND_API_URL}installer/plans`;
      Http.get(url)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

/**
 * Get subscribed plan details and seat status of current user
 * @param {number} usedSeats - Optional count of used seats
 */
export function getInstallerSeatStatus(usedSeats = 0) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      const query = usedSeats !== undefined ? `?used_seats=${usedSeats}` : "";
      const url = `${LARAVEL_BACKEND_API_URL}installer/seat-status${query}`;
      Http.get(url)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

/**
 * Subscribe to a plan or purchase installer seats (returns Stripe checkout_url)
 * @param {number|string} planId
 * @param {number} seats
 */
export function subscribeInstallerSeats(planId, seats) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      const url = `${LARAVEL_BACKEND_API_URL}installer/subscribe`;
      const formData = new FormData();
      formData.append("plan_id", planId);
      formData.append("seats", seats);

      Http.post(url, formData)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}

/**
 * Cancel auto-renewal for an individual subscription
 * @param {number|string} subscriptionId
 */
export function cancelInstallerSubscription(subscriptionId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      const url = `${LARAVEL_BACKEND_API_URL}installer/cancel`;
      const formData = new FormData();
      formData.append("subscription_id", subscriptionId);

      Http.post(url, formData)
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
}
